export  class UsersEntity {
    user_id:number=0;
    email :String = "";
    password :string = "";
    gender:String = "";
    is_bayi:number = 0;
    lastname: String = "";
    name: String = "";
    user_permission_type_id : number = 1;
    created_at:string | null = null;
}